import { GebiedsprognoseConfig } from './apiRequests'

export type { GebiedsprognoseConfig }

export interface GebiedsprognoseFormData {
  naam: string
  omschrijving: string
  gemeente_code: string
  sp_id: string
  bjaar: number
  ejaar: number
  gebiedsvoorkeur_code: string
  leeftijdsprofiel_code: string
  gwb: number
  woningbouwplanning_code: string
  minmax_code: string
  aanname_mfmp: string
  aanname_fc: string
  migratiecorrectie: number
  grens_woningtoename: number
  fc_max: number
  fc_daling: number
  nieuwbouw_demping: number
}

export const defaultFormData: GebiedsprognoseFormData = {
  naam: '',
  omschrijving: '',
  gemeente_code: '',
  sp_id: '',
  bjaar: 2025,
  ejaar: 2040,
  gebiedsvoorkeur_code: '',
  leeftijdsprofiel_code: '',
  gwb: 2.0,
  woningbouwplanning_code: '',
  minmax_code: '',
  aanname_mfmp: '5',
  aanname_fc: '5',
  migratiecorrectie: 0.9,
  grens_woningtoename: 1.1,
  fc_max: 1.05,
  fc_daling: 0.025,
  nieuwbouw_demping: 0.4,
}
